import { UscgSymbol } from 'components/MapPage/CorporateViewTabs/LayersTab/utils/uscgSymbology';
import type { Geometry } from 'geojson';

type BoomResourceSubType = 'proposedBoom' | 'completedBoom';

export const BOOM_RESOURCES = {
  COMPLETED: 'completedBoom' as const,
  PROPOSED: 'proposedBoom' as const,
} satisfies Record<string, BoomResourceSubType>;

export const OIL_SPILL_RESOURCE = 'oilSpill' as const;

export interface LocationPolygonProperties {
  polygonColor?: string;
  polygonOpacity?: number;
}

export interface CreateIcsIncidentLocationBody {
  name: string;
  resourceType: UscgSymbol;
  description?: string;
  geometry: Geometry;
  properties: LocationPolygonProperties;
  internalLayerVersionId?: string | null;
}

export interface IcsIncidentLocation extends CreateIcsIncidentLocationBody {
  id: string;
  groupGuid: string;
  createdAt: string;
  updatedAt: string;
}

export type UpdateIcsIncidentLocationBody = CreateIcsIncidentLocationBody & {
  id: string;
};
